export default __webpack_public_path__ + "static/media/privacy_policy.3002d7a0.md";